@if (checkboxMode) {
  <ion-checkbox
    data-testid="checkbox"
    [disabled]="!canAdd"
    [checked]="itemCount === 1"
    color="secondary"
  (click)="onCheck()"></ion-checkbox>
}
@if (!checkboxMode) {
  <div class="limit" data-testid="limit-caption">{{ limitCaption }}</div>
  @if (canRemove) {
    <ion-button
      data-testid="remove-button"
      class="remove-button"
      fill="clear"
      shape="round"
      (click)="onRemove()">
      <ion-icon slot="icon-only" name="remove-circle-outline"></ion-icon>
    </ion-button>
  }
  @if (itemCount > 0) {
    <div class="count" data-testid="count">{{ itemCount }}</div>
  }
  <ion-button
    data-testid="add-button"
    class="add-button"
    [disabled]="!canAdd"
    fill="clear"
    shape="round"
    (click)="onAdd()">
    <ion-icon slot="icon-only" name="add-circle-outline"></ion-icon>
  </ion-button>
}
